import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useUserAdd } from "hooks/citajteo/user/useUserAdd";
import { QUERY_KEYS } from "constant/react_query";
import UserForm, {
  UserFormState,
} from "components/admin/common/user/UserForm/UserForm";
import { USER_TYPE } from "constant/user/user.constant";
import toast from "react-hot-toast";

const EMPTY_FORM: UserFormState = {
  un: "",
  email: "",
  firstName: "",
  lastName: "",
  uType: USER_TYPE.EDITOR,
  pw: "",
  pwRepeat: "",
};

const UserNew: React.FC = () => {
  const navigate = useNavigate();
  const { userAddMutate } = useUserAdd({
    invalidateKeys: [QUERY_KEYS.CITAJTEO_USER_SEARCH],
    errorHandle: (error: any) => {
      console.error("Error adding user:", error);
      toast.error("Greška prilikom dodavanja novog korisnika.");
    },
  });
  const [form, setForm] = useState<UserFormState>(EMPTY_FORM);
  const [errorText, setErrorText] = useState("");

  const handleChange =
    (field: keyof UserFormState) =>
    (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
      setForm((currentForm) => ({
        ...currentForm,
        [field]: event.target.value,
      }));
    };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setErrorText("");

    const trimmedUserName = form.un.trim();
    const trimmedPassword = form.pw.trim();
    const trimmedPasswordRepeat = form.pwRepeat.trim();

    if (trimmedUserName === "") {
      setErrorText("Korisnicko ime ne sme biti prazno.");
      return;
    }

    if (trimmedPassword === "") {
      setErrorText("Lozinka ne sme biti prazna.");
      return;
    }

    if (trimmedPassword !== trimmedPasswordRepeat) {
      setErrorText("Lozinka i ponovljena lozinka moraju biti iste.");
      return;
    }

    userAddMutate(
      {
        un: trimmedUserName,
        email: form.email.trim(),
        firstName: form.firstName.trim(),
        lastName: form.lastName.trim(),
        uType: form.uType,
        pw: trimmedPassword,
      },
      {
        onSuccess: (data) => {
          console.log("data", data);

          if (data === null) {
            toast.error("Greška prilikom dodavanja novog korisnika.");
            return;
          }

          toast.success("Uspešno dodavanje novog korisnika.");
          navigate("/admin-dashboard/user-li");
        },
        onError: (error) => {
          console.error("Error adding user:", error);
          toast.error("Greška prilikom dodavanja novog korisnika.");
        },
      },
    );
  };

  const handleReset = () => {
    setForm(EMPTY_FORM);
    setErrorText("");
  };

  return (
    <FullWidth>
      <div className="App">
        <UserForm
          values={form}
          errorText={errorText}
          onChange={handleChange}
          onSubmit={handleSubmit}
          onReset={handleReset}
        />
      </div>
    </FullWidth>
  );
};

export default UserNew;

const FullWidth = styled.div`
  width: 100%;
`;
